<template>
    <div id="links-container" class="sign_1 bg-cover">
        <a href="https://www.patreon.com/Lunydoobles" target="_blank" class="logo-container"><img class="logo" src="../assets/logo_patreon.png" alt="patreon"></a>
        <a href="https://www.twitter.com/lunydoobles" target="_blank" class="logo-container"><img class="logo" src="../assets/logo_twitter.png" alt="twitter"></a>
        <a href="rss.xml" class="logo-container"><img class="logo-no-round" src="../assets/logo_rss.png" alt="subscribe"></a>
        <a href="https://knifebeetle.angelfire.com/" target="_blank" class="logo-container"><img class="logo-no-round" src="../assets/kb.png" alt="artstation"></a>
    </div>
</template>


<script>

export default {
  name: 'links',
  components: {
    
  },
  methods: {

  }
}
</script>

<style scoped>
#links-container{
	margin-left: auto;
	margin-right: auto;
	margin-top: 25px;
    padding: 5%;
	display: flex;
	justify-content: space-evenly;
	align-items: center;
    max-height: 8vw;
}

.sign_1 {
	background-image: url('../assets/sign_1.png');
}

.logo-container{
    max-width: 20%;
    max-height: 20%;
}

.logo{
    max-width: 50%;
    max-height: 50%;
    border-radius: 50%;
}

.logo-no-round{
    max-width: 50%;
    max-height: 50%;
}
/*
.logo:hover{
    background-color: #fff;
    -moz-shadow: 0 0 5px #fff;
    -webkit-shadow: 0 0 5px #fff;
    shadow: 0px 0px 5px #fff;
}

.logo-no-round:hover{
    background-color: #fff;
    -moz-box-shadow: 0 0 5px #fff;
    -webkit-box-shadow: 0 0 5px #fff;
    box-shadow: 0px 0px 5px #fff;
}
*/
</style>